import React from "react";
import "./ToolsComponent.css";

const ToolsComponent = () => {
  return (
    <>
      <div className="codepenskills">
        <div className="each html">
          <div className="box">
            <div className="content">
              <h2>Web Development</h2>
              {/* <!-- <p>Building interactive and responsive websites for a seamless user experience.</p> --> */}
              <p>HTML, CSS, Javascript, React, NodeJS</p>
              {/* <!-- <i className="fa-brands fa-html5"></i> --> */}
              <img
                width="50"
                height="50"
                src="https://img.icons8.com/ios-filled/50/google-code.png"
                alt="google-code"
              />
            </div>
          </div>
        </div>
        <div className="each css">
          <div className="box">
            <div className="content">
              <h2>App Development</h2>
              {/* <!-- <p>Developing mobile applications to provide functionality and engagement on smartphones.</p> --> */}
              <p>Java, XML, Android Studio</p>
              {/* <!-- <i className="fa-brands fa-css3"></i> --> */}
              <img
                width="50"
                height="50"
                src="https://img.icons8.com/ios-filled/50/android-os.png"
                alt="android-os"
              />
            </div>
          </div>
        </div>
        <div className="center">
          <div className="box">
            <h2>SKILLS</h2>
          </div>
        </div>
        <div className="each js">
          <div className="box">
            <div className="content">
              {/* <!-- <i className="fa-brands fa-js"></i> --> */}
              <img
                width="50"
                height="50"
                src="https://img.icons8.com/ios-filled/50/windows10-personalization.png"
                alt="windows10-personalization"
              />
              <h2>Graphic Design</h2>
              {/* <!-- <p>Creating visually appealing graphics and web designs to enhance online presence.</p> --> */}
              <p>Canva, Figma, Adobe</p>
            </div>
          </div>
        </div>
        <div className="each ng">
          <div className="box">
            <div className="content">
              {/* <!-- <i className="fa-brands fa-angular"></i> --> */}
              <img
                width="50"
                height="50"
                src="https://img.icons8.com/ios/50/combo-chart--v1.png"
                alt="combo-chart--v1"
              />

              <h2>Data Analytics</h2>
              {/* <!-- <p>Crafting desktop applications using Python to offer powerful and versatile solutions for various purposes.</p> --> */}
              <p>Power BI, Advanced Excel</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ToolsComponent;
